import { HTMLAttributes } from 'react';
import classNames from 'classnames';
import { omit } from 'sdk';

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}
export default function Container({ children, ...props }: ContainerProps) {
  return (
    <div
      className={classNames(
        'max-w-site mx-auto p-site-padding',
        props.className
      )}
      {...omit(props, ['className'])}
    >
      {children}
    </div>
  );
}
